import React from 'react';
import { connect } from 'react-redux';

import BaseComponent from '../../baseClasses/BaseComponent';
import errorIcon from '../../assets/images/message-error-icon.svg';
import infoIcon from '../../assets/images/message-success-icon.svg';
import successIcon from '../../assets/images/message-secure-success-icon.svg';
import Animate from '../../components/Animate';
import dataModel from '../../models/DataModel';
import './InfoErrorSlider.scss';
import { setTimeout } from 'timers';

export class InfoErrorSlider extends BaseComponent {

  constructor(props) {
    super(props);

    this.info = 0;
    this.warning = 1;
    this.error = 2;
    this.catastrophic = 3;

    this.state = { leftPosition: window.innerWidth + 200 };
  }

  handleClick() {
    this.props.dataModel.dismissInfoErrorMessage();
  } 
  
  render() {
    const { infoErrorMessage } = this.props;
    const _this = this;

    if (infoErrorMessage && infoErrorMessage != 'none') {
      switch (infoErrorMessage.severity) {
      case 0:  
        this.messageIcon = infoIcon;
        break;
      case 1:
        this.messageIcon = successIcon;
        break;
      case 2:
        this.messageIcon = errorIcon;
        break;
      case 3:
        this.messageIcon = errorIcon;
        break;
      default:
        this.messageIcon = errorIcon;
        break;
      }
      this.message = infoErrorMessage.message;

      if (infoErrorMessage.duration) {
        this.timer = setTimeout(() => {
          _this.handleClick();
        }
          , !this.props.mobileBridge.isMobile ? infoErrorMessage.duration : 30000);
      }
      else {
        this.timer = setTimeout(() => {
          _this.handleClick();
        }
          , !this.props.mobileBridge.isMobile ? 7000: 30000);
      }
    }  
    else if (infoErrorMessage == 'none') {
      setTimeout(() => {
        _this.handleClick();
      }
        , !this.props.mobileBridge.isMobile ? 10000: 30000);
    }

    return (
      <div id="info-error-display" className="info-error-display" onClick={this.handleClick}>
        <Animate key="animate-error-display-in" component_id="info-error-display" duration={500} property={{
          left: {
            startVal: this.props.mobileBridge.isMobile ? 0 : window.innerWidth,
            endVal: this.props.mobileBridge.isMobile ? 0 : window.innerWidth - 424,
          },
        }} onUnmount={false} />  
        <Animate key="animate-error-display-out" component_id="info-error-display" duration={500} property={{
          left: {
            startVal: this.props.mobileBridge.isMobile ? 0 : window.innerWidth - 426,
            endVal: window.innerWidth,
          },
        }} onUnmount={true} />
        <img className="message-icon" src={this.messageIcon} alt="message" />
        <span className="message-text" >{this.message}</span>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    dataModel: dataModel,
    infoErrorMessage: state.main.infoErrorMessage,
    mobileBridge: dataModel.mobileBridge,
  };
};

// For handling state change from a dispatch
const mapDispatchToProps = (dispatch) => {
  return {
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(InfoErrorSlider);



// WEBPACK FOOTER //
// ./src/components/InfoErrorSlider/index.js